/*
    模块组件
    ChenM

    说明
    主页广告图展示

    版本
    1.0

    传参
        showAdvertise Boolean : 必填  当前页面的是否展示
        advertiseData String : 非必填 当前页面的广告图
        ifCheckbox Boolean : 必填 今天是否点击了下次继续展示
    依赖
    /style/2019/h5/css/common.css
    vue.js

    案例
    <Advertise :showAdvertise="showAdvertise" :advertiseData="advertiseData" :ifCheckbox="ifCheckbox" @checkbox="checkbox"></Advertise>
*/
<template>
    <div class="Ad_popup">
        <!-- S 开屏弹窗 -->
        <Popup v-model:show="showAdvertise">
            <div class="wrap">
                <img class="main_img" :src="advertiseData.url">
                <a :href="advertiseData.link" v-show="showLink"><img class="main_link" :src="link_img"></a>
                <div class="popup_btn">
                    <div class="custom_check" @click="customCheck"><div :class="{'custom_check_true':ifCheckbox}"></div></div><span>今天内不再提示</span>
                </div>
                <img class="close_img" :src="close_img" @click="showAdvertise=false">
            </div>
        </Popup>
        <!-- E 开屏弹窗 -->
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, watch, onActivated} from 'vue';
import { Popup, Checkbox, } from 'vant';
import router from "@/router"
import link_img from "@/assets/images/index/img_link.png"
import close_img from "@/assets/images/index/img_close.png"



export default defineComponent({
    name: 'Advertise',
    props: {
        showAdvertise: {
            type: Boolean,
            default: false,
        },
        advertiseData: {
            type: Object,
            default: '',
        },
        ifCheckbox:{
            type: Boolean,
            default: false,            
        },
        showLink:{
            type: Boolean,
            default: true,            
        },              
    },
    components:{Popup, Checkbox},
    setup(props,{ emit }) {
        const state = reactive({
            ifCheckbox: false,
            showAdvertise: false,
            link_img: link_img,
            close_img: close_img,
        });
        const data = reactive({});
        const methods = {
            back: () => route.back(),
            goState: (o) => router.push(o),
            customCheck: () => state.ifCheckbox = !state.ifCheckbox
        }; //需要对外暴露的方法

        watch(()=>state.ifCheckbox, (newValue, oldValue) => {
            emit('checkbox',newValue)
        });
        watch(()=>props.showAdvertise, (newValue, oldValue) => {
            state.showAdvertise = props.showAdvertise
            emit('HaveAdvertise',newValue)
        });
        watch(()=>props.ifCheckbox, (newValue, oldValue) => {
            state.ifCheckbox = props.ifCheckbox
        });        
        onActivated(() => {
            state.ifCheckbox = props.ifCheckbox
            state.showAdvertise = props.showAdvertise        
        });

        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods
        };
    },
});
</script>
<style lang="less" scoped>
@charset "utf-8";
@import "./Advertise.less";
</style>